module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/visa_cid-5373fb2b6b751301cf6cafc3b52eddc4.gif";